interface AvatarProps {
  initials?: string
  src?: string
  square?: boolean
  className?: string
}

export default function Avatar({
 initials, src, square = false, className = '' 
}: AvatarProps) {
  if (src) {
    return (
      <img 
        src={src} 
        alt=""
        className={`${square ? 'rounded-md' : 'rounded-full'} ${className}`}
      />
    )
  }
  
  return (
    <div className={`${square ? 'rounded-md' : 'rounded-full'} bg-zinc-500 text-white flex items-center justify-center ${className}`}>
      {initials}
    </div>
  )
} 